/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : EESWMSavedLinkageCard.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Typography, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { componentStyle } from "../../../config/appTheme";
import CloseIcon from "@mui/icons-material/Close";

function EESWMSavedLinkageCard({
  savedLinkages,
  setSavedLinkages,
  entityType,
}) {
  const getKeyBasedOnEntity = () => {
    switch (entityType) {
      case "ee":
        return {
          idKey: "ee_id",
          displayKey: "Assembly Number ",
          displayValue: (item) => item?.addOn?.assembly_number,
        };
      case "swm":
        return {
          idKey: "swm_id",
          displayKey: "Number ",
          displayValue: (item) => item?.addOn?.name,
        };
      case "vs":
        return {
          idKey: "vs_id",
          displayKey: "Name",
          displayValue: (item) => {
            return item?.addOn?.name;
          },
        };
      default:
        return {
          idKey: "ee_id",
          displayKey: "Assembly Number ",
          displayValue: (item) => item?.addOn?.assembly_number,
        };
    }
  };

  const [modifiedLinkItems, setModifiedLinkItems] = useState([]);
  const entityConfig = getKeyBasedOnEntity();

  useEffect(() => {
    let array =
      savedLinkages?.flatMap(
        (item) =>
          item.legal?.map((legalItem) => ({
            ...legalItem,
            ...item,
          })) || [],
      ) || [];
    setModifiedLinkItems(array);
  }, [savedLinkages]);

  // sonar handler function
  const handleRemoveLinkage = (item) => {
    const updatedLinkages = savedLinkages
      .map((linkage) => {
        if (linkage[entityConfig.idKey] === item[entityConfig.idKey]) {
          const filteredLegal = linkage.legal.filter(
            (legal) => legal.lr_id !== item.lr_id,
          );

          return filteredLegal.length > 0
            ? { ...linkage, legal: filteredLegal }
            : null;
        }

        return linkage;
      })
      .filter(Boolean);

    setSavedLinkages(updatedLinkages);
  };
  return (
    <Box>
      {modifiedLinkItems?.map((item, index) => {
        return (
          <Box
            key={index}
            sx={{
              mb: 2,
              ...componentStyle.font.text,
              color: "white",
              backgroundColor: "black",
              display: "flex",
              gap: 2,
              p: 1,
            }}
          >
            <IconButton
              onClick={() => handleRemoveLinkage(item)}
              sx={{ color: "white", ml: 1, mr: 1, mt: -1 }}
            >
              <CloseIcon />
            </IconButton>
            <Typography>{`${entityConfig.displayKey
              }: ${entityConfig.displayValue(item)}`}</Typography>
            <Typography>{`Description: ${item?.description}`}</Typography>
          </Box>
        );
      })}
    </Box>
  );
}

export default EESWMSavedLinkageCard;
